import { render, staticRenderFns } from "./TicketModalMobile.vue?vue&type=template&id=5062537c"
import script from "./TicketModalMobile.vue?vue&type=script&lang=js"
export * from "./TicketModalMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports